import { t } from '../../i18next';
import { CommitResultType } from '../../shared/types';
import { postRequest } from '../../shared/utils';
import { getPoKubuMapping } from './services/poKubu';
import { validateSaphHtzService } from './services/validateHtzService';
import { validateSheet1HtzService } from './services/validateSheet1HtzService';

export async function fetchDataForCommit({ screenGridId, upsertedRows }) {
  try {
    const poKubuMapping = await getPoKubuMapping(screenGridId);
    const saphIdActions = upsertedRows.map((row) =>
      validateSaphHtzService(row.npi_htz, screenGridId),
    );
    const saphIdResults = await Promise.allSettled(saphIdActions);
    const saphIds = {};
    saphIdResults.forEach((result, i) => {
      const { npi_htz: npiHtz } = upsertedRows[i];
      if (result.status === 'fulfilled') {
        const { npi_tblhtzinfo: npiTblhtzinfo } = result.value;
        const eSaphId = npiTblhtzinfo.length ? npiTblhtzinfo[0].e_saph_id : null;
        saphIds[npiHtz] = eSaphId;
      }
    });

    // sheet1 actions
    const sheet1HtzActions = upsertedRows.map((row) =>
      validateSheet1HtzService(row.npi_htz, screenGridId),
    );
    const sheet1HtzResults = await Promise.allSettled(sheet1HtzActions);
    const sheet1Htzs = {};
    sheet1HtzResults.forEach((result, i) => {
      const { npi_htz: npiHtz } = upsertedRows[i];
      sheet1Htzs[npiHtz] = result.status === 'fulfilled' ? result.value : null;
    });

    return { poKubuMapping, saphIds, sheet1Htzs };
  } catch (e) {
    console.error('MoB fetch action failed.', e.message);
    return {};
  }
}

export async function commitNpiBoardChanges({ htz, screenGridId, tables, finRepoTable }) {
  const resultSet: CommitResultType = {
    errors: [],
    allTableSuccess: true,
    success: true,
  };
  // Mutation actions
  try {
    const npiResult = await postRequest('/api/tables', {
      screenGridId,
      tables,
    });
    if (npiResult.errors) {
      resultSet.errors.push({
        message: t('mob.insert_update_error', {
          msg: npiResult.errors[0].message,
          htz,
        }),
      });
      resultSet.success = false;
      return resultSet;
    }

    if (finRepoTable) {
      await postRequest('/api/tables', {
        screenGridId,
        tables: [finRepoTable],
      });
    }
  } catch (error) {
    resultSet.success = false;
    resultSet.errors.push({
      message: t('mob.insert_update_error', {
        msg: error.message,
        htz,
      }),
    });
  }
  return resultSet;
}
